import { StateSchema } from "@/app/providers/StoreProvider";

export const getPaymentMethodsIsLoading = (state: StateSchema) => state.payment?.paymentMethodsIsLoading;
export const getPaymentMethodsError = (state: StateSchema) => state.payment?.paymentMethodsError;
export const getPaymentMethodsData = (state: StateSchema) => state.payment?.paymentMethodsData;
